var map = {
	"./Apprentissages ludiques (1).jpg": 6440,
	"./Apprentissages ludiques (2).jpg": 3534,
	"./Apprentissages ludiques (3).jpg": 3334,
	"./Apprentissages ludiques.jpg": 6510,
	"./Approche ludique (2).jpg": 3887,
	"./Approche ludique.jpg": 1688,
	"./Artful English Club (1).jpg": 87,
	"./Artful English Club.jpg": 6833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5521;